import axios from 'axios';
import { BASE_URL, JWT_APP_ID } from '../../config/URL';
import { generateErrorDetail } from '../../utils';

export const getPages = () => async (dispatch, getState) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/catalog/v1.1/pages?locale=en`,
      {
        headers: {
          'Cloudfront-JWT-AppId': JWT_APP_ID,
        },
      }
    );

    const pageData = response.data.data;
    const formatPageData = pageData.map((data) => ({
      ...data,
      friendlyId: data.friendlyId.toLowerCase(),
    }));

    dispatch({
      type: 'GET_PAGES',
    });

    dispatch({
      type: 'GET_PAGES_SUCCESS',
      payload: formatPageData,
    });
  } catch (err) {
    const errorData = generateErrorDetail(err);

    dispatch({
      type: 'GET_PAGES_FAILED',
      err: errorData,
    });
  }
};
